import {Container, Box } from '@mui/material';
import { styled } from "@mui/material/styles";

const StyledContainer = styled(Box)({
  width: '100%', 
  backgroundColor: '#E5E5E5',
  padding: 20
});

export default StyledContainer;